module.exports = __webpack_public_path__ + "img/person.e94ee93e.svg";